<template>
	<div class="panebox">
		<div class="pane">
			<div class="pane_tit">{{ ranqiInfo && ranqiInfo.type == 'jumin'? '居民燃气安全信息' : '非居民燃气安全信息' }}</div>
			<div class="pane_cont" v-if="ranqiInfo && ranqiInfo.type == 'jumin'">
				<el-row :gutter="20">
					<el-col :span="8">
						<div>供气企业：<span>{{ ranqiInfo.gongqiqiye }}</span></div>
					</el-col>
					<el-col :span="24" class="coltit">
						<div>用户基本信息</div>
					</el-col>
					<el-col :span="8">
						<div>姓名：<span>{{ ranqiInfo.xingming }}</span></div>
					</el-col>
					<el-col :span="16">
						<div>联系方式：<span>{{ ranqiInfo.lianxifangshi }}</span></div>
					</el-col>
					<el-col :span="8">
						<div>燃气瓶数量：<span>{{ ranqiInfo.ranqipingshuliang }}</span></div>
					</el-col>
					<el-col :span="16">
						<div>具体地址：<span>{{ ranqiInfo.jutidizhi }}</span></div>
					</el-col>
					<el-col :span="24" class="coltit">
						<div>隐患排查情况</div>
					</el-col>
					<el-col :span="8">
						<div>燃烧器具：<span>{{ ranqiInfo.ranshaoqiju }}</span></div>
					</el-col>
					<el-col :span="8">
						<div>配套管阀：<span>{{ ranqiInfo.peitaoguanfa }}</span></div>
					</el-col>
					<el-col :span="8">
						<div>泄露安全保护装置：<span>{{ ranqiInfo.xieluanquan }}</span></div>
					</el-col>
					<el-col :span="8">
						<div>排查人：<span>{{  ranqiInfo.paicharen }}</span></div>
					</el-col>
					<el-col :span="24" v-if="ranqiInfo.beizhu">
						<div>备注：<span>{{ ranqiInfo.beizhu }}</span></div>
					</el-col>
				</el-row>
			</div>

			<div class="pane_cont" v-else>
				<el-row :gutter="20">
					<el-col :span="8">
						<div>供气企业：<span>{{ ranqiInfo.gongqiqiye }}</span></div>
					</el-col>
					<el-col :span="24" class="coltit">
						<div>用户基本信息</div>
					</el-col>
					<el-col :span="12">
						<div>营业执照名称：<span>{{ ranqiInfo.yingyezhizhao }}</span></div>
					</el-col>
					<el-col :span="12">
						<div>统一社会信用代码：<span>{{ ranqiInfo.xinyongdaima }}</span></div>
					</el-col>
					<el-col :span="12">
						<div>店面门头名称：<span>{{ ranqiInfo.mentoumingcheng }}</span></div>
					</el-col>
					<el-col :span="12">
						<div>具体地址：<span>{{ ranqiInfo.jutidizhi }}</span></div>
					</el-col>
					<el-col :span="12">
						<div>负责人：<span>{{ ranqiInfo.fuzheren }}</span></div>
					</el-col>
					<el-col :span="12">
						<div>联系方式：<span>{{ ranqiInfo.lianxifangshi }}</span></div>
					</el-col>
					<el-col :span="12">
						<div>场所类型：<span>{{ ranqiInfo.changsuoleixing }}</span></div>
					</el-col>
					<el-col :span="12">
						<div>用气类型：<span>{{  ranqiInfo.yongqileixing }}</span></div>
					</el-col>
					<el-col :span="12">
						<div>网格员：<span>{{ ranqiInfo.jobmanname }}</span></div>
					</el-col>
					<el-col :span="24" v-if="ranqiInfo.beizhu">
						<div>备注：<span>{{ ranqiInfo.beizhu }}</span></div>
					</el-col>
				</el-row>
			</div>
		</div>

		
	</div>
</template>

<script>
	export default {
		name: "detail",
		components: {},
		props: {
			ranqiInfo: {
				type: Object,
				default: ()=>{
					return {}
				}
			}
		},
		data() {
			return {
				taskInfo: {},
			}
		},
		watch: {
			ranqiInfo: {
				handler(newVal, oldVal) {
					if (newVal) {
						this.getInfo();
					}
				},
				deep:true,
				immediate: true
			}
		},
		created() {},
		mounted() {},
		computed: {},
		methods: {
			//获取任务详情
			getInfo() {
				console.log(this.ranqiInfo)
			},
		}
	}
</script>

<style lang="scss" scoped>
	.pane {

		.pane_tit {
			padding: 10px 20px;
			border-bottom: 1px solid #ddd;
			background: #f9f9f9;
			font-size: 16px;
			color: #333;
		}

		.pane_cont {
			padding: 20px;
			background: #fff;

			.el-row {
				>div {
					margin-bottom: 14px;
					font-weight: bold;
					color: #333;

					&.coltit{
						font-size: 18px;
						padding: 10px;
						margin-top: 30px;
						background-color: #f0f0f0;
					}
					span {
						font-weight: normal;
						color: #666;
					}
				}
			}

			.flow {
				max-height: 360px;
				overflow: auto;
			}

			.flowitem {
				position: relative;
				padding-left: 30px;

				.icon {
					position: absolute;
					height: 100%;
					background: #e4e7ed;
					width: 1px;
					top: 15px;

					&::before {
						position: absolute;
						content: '';
						left: 0;
						top: 0;
						transform: translate(-50%, -50%);
						width: 15px;
						height: 15px;
						background: #e4e7ed;
						border-radius: 50%;
					}
				}

				&:last-child {
					.icon {
						height: 0;
					}
				}

				.desc {
					padding: 5px 30px 40px;
					min-height: 40px;
					line-height: 1.6em;

					>div {
						display: flex;
						margin-bottom: 5px;

						.filed {
							width: 120px;
							text-align: right;
						}
					}

					.imgs {
						display: flex;

						img {
							height: 90px;
							width: auto;
							margin-right: 10px;
						}
					}
				}
			}
		}
	}

	.pagebox {
		padding-top: 20px;
	}
</style>